export const getRequestStatus = (state, id) => {
  return state.api && state.api.requests && state.api.requests[id] ? state.api.requests[id].status : null
}
